import { defineEvent } from '../types/event';
export var PRODUCT_CARD_CAROUSEL_UPDATE = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            transform: function (input) { return ({
                eventName: 'image_carousel__slide_in_view',
                index: input.index
            }); }
        },
        {
            name: 'Heap',
            transform: function (input) { return ({
                eventName: 'productCard_imagecarouselupdate',
                index: input.index,
                productCard_title: input.title,
                productCard_position: input.position,
                productCard_shopifyId: input.shopifyId
            }); }
        }
    ]
});
